import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import { forwardRef } from 'react';

import { ReactComponent } from './file-blank-exchange-cross-delete.svg';

export const FileBlankExchangeCrossDelete = forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props, ref) => (
  <SvgIcon ref={ref} component={ReactComponent} inheritViewBox {...props} />
));

if (process.env.NODE_ENV !== 'production') {
  FileBlankExchangeCrossDelete.displayName = 'FileBlankExchangeCrossDelete';
}
